import { render } from "./main-table-card.vue?vue&type=template&id=0ff03483&ts=true"
import script from "./main-table-card.vue?vue&type=script&lang=ts"
export * from "./main-table-card.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__